exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.important-note {\n    color: #F15C61;\n}\n", ""]);

// exports
